import { inquiryOfferDeadlineEnd } from '@/utils/inquiryOfferDeadline';

/** True when the inquiry deadline for offer submission has passed. No deadline means offers can still be submitted. */
export function isInquiryOfferDeadlinePassed(deadline?: string | null): boolean {
  if (!deadline) return false;
  return inquiryOfferDeadlineEnd(deadline) < new Date();
}
